// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remain-height{height:calc(100% - 51px)}.remain-height-chat-diaglogue{height:calc(100% - 111px)}.chat-content{width:calc(100% - 300px)}.chat-list{width:300px}", ""]);
// Exports
module.exports = exports;
